import { Pipe, PipeTransform } from '@angular/core';

import { OpportunityType } from '../../sales-opportunities/interface';

@Pipe({
  name: 'getTypeNameFromId',
})
export class GetTypeNameFromIdPipe implements PipeTransform {
  transform(id, types: OpportunityType[]): OpportunityType | null {
    return findTypeNameFromId(types, id);
  }
}

function findTypeNameFromId(types: OpportunityType[], id: string): OpportunityType | null {
  return types.find((type) => type.id === id) || null;
}
